import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import { LatestProspects, ProspectTable } from "@amtana/prospect-client";

import { PROSPECT_CATALOGS } from "./model/prospect-copy.ts";
import { PROSPECT_ERROR_COPY } from "./model/prospect-error-copy.ts";
import { SCORING_CATALOGS } from "./model/scoring-copy.ts";

export const prospectBrowserModule: BrowserModule = defineBrowserModule("prospect")
  .withErrorCopy(PROSPECT_ERROR_COPY)
  .withScreens({
    list: {
      path: "/prospects",
      title: phrase(PROSPECT_CATALOGS, "listScreenTitle"),
      layout: "app",
      load: () => import("./ui/sections/prospects-screen.tsx"),
    },
    detail: {
      path: "/prospects/:prospectId",
      title: phrase(PROSPECT_CATALOGS, "detailScreenTitle"),
      layout: "app",
      load: () => import("./ui/sections/prospect-screen.tsx"),
    },
    // S8.04 (ADR-006 §6-7): the seeded "lead-scoring" flag's real gated surface in the
    // browser. Off, this path falls back to the not-found screen instead of rendering.
    scoring: {
      path: "/scoring",
      title: phrase(SCORING_CATALOGS, "screenTitle"),
      layout: "app",
      flag: "lead-scoring",
      load: () => import("./ui/sections/scoring-screen.tsx"),
    },
  })
  .withLends([
    { token: ProspectTable, load: () => import("./ui/sections/prospect-table.tsx") },
    { token: LatestProspects, load: () => import("./ui/sections/latest-prospects.tsx") },
  ])
  .withNavigation([
    {
      id: "prospects",
      group: "leads",
      label: phrase(PROSPECT_CATALOGS, "navProspects"),
      href: "/prospects",
      icon: "users",
      order: 130,
    },
    {
      id: "scoring",
      group: "leads",
      label: phrase(SCORING_CATALOGS, "title"),
      href: "/scoring",
      icon: "sparkles",
      order: 135,
      flag: "lead-scoring",
    },
  ]);
